import cookieHelper from '@/helpers/cookieHelper'

export default {
  state: {
    dataFromCookies: {
      blackBottom: !!+cookieHelper.getCookie('black_bottom'),
      topCart: !!+cookieHelper.getCookie('top_cart'),
      newCart: !!+cookieHelper.getCookie('new_cart_1'),
      ab2: !!+cookieHelper.getCookie('ab_2'),
      ab3: !!+cookieHelper.getCookie('ab_3'),
      technicalExpertFormInModal: !!+cookieHelper.getCookie('technical_expert_form_in_modal'),
      // 0 - скрыт, 1 - на странице товара под фото, 2 - на странице товара над доставкой
      technicalExpertBlockVisibility: +cookieHelper.getCookie('technical_expert_block_visibility') || 0
    }
  },
  getters: {
    cartModalName (state) {
      // return state.dataFromCookies.newCart ? 'cart-modal-new' : 'cart-modal'
      return 'cart-modal'
    }
  }
}
